import cookies from '@/utils/cookie'
const httpFirst = 'https://'
const httpPrefix = 'http://'

/*
    httpAddress, // 请求域名
    httpUser, // 用户
    httpContent,  // 内容
    httpImg,
    httpExtract, // 充值
    httpIdAuth,  // java接口域名
    signKey,  // 3.5.0版本验签
    newSignKey, // 安卓：>=3.8.1 IOS:  >=3.7.0版本验签
    signKeyV3
*/
let [
  httpAddress,
  httpUser,
  httpContent,
  httpImg,
  httpExtract,
  httpIdAuth,
  signKeyCollect, // 埋点验签
  signKeyV0, // 老版本验签
  signKey, // 3.5.0版本验签
  newSignKey, // 3.8.0及以上版本验签
  signKeyV3, // 5.0.1及以上版本验签
] = ''

signKeyCollect = process.env.VUE_APP_HTTP_KEY_SIGNCOLLECT;
signKeyV0 = process.env.VUE_APP_HTTP_KEY_SIGNV0;
signKey = process.env.VUE_APP_HTTP_KEY_SIGNV1;
if ((window as any).mb === "pc") {
    newSignKey = process.env.VUE_APP_HTTP_KEY_SIGNV2_PC;
    signKeyV3 = process.env.VUE_APP_HTTP_KEY_SIGNV3_PC;
} else if ((window as any).mb === "ios") {
    newSignKey = process.env.VUE_APP_HTTP_KEY_SIGNV2_IOS;
    signKeyV3 = process.env.VUE_APP_HTTP_KEY_SIGNV3_IOS;
} else {
    newSignKey = process.env.VUE_APP_HTTP_KEY_SIGNV2_ANDROID;
    signKeyV3 = process.env.VUE_APP_HTTP_KEY_SIGNV3_ANDROID;
}

// 是否为开发环境 || 测试环境
if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test') {
  httpAddress = `${httpPrefix}charge-api-dev.996box.com`
  httpUser = `${httpPrefix}user-api-dev.996box.com`
  httpContent = `${httpPrefix}pc-api-dev.996box.com`
  httpImg = `${httpPrefix}uploads-api-dev.996box.com`
  httpExtract = `${httpPrefix}pay-api-dev.996box.com`
  httpIdAuth = `${httpPrefix}test-api.996box.com`
}
// 准生产环境
if (process.env.NODE_ENV === 'pre') {
  httpAddress = `${httpFirst}charge-api-pre.996box.com` // 请求域名
  httpUser = `${httpFirst}user-api.pre.xqhuyu.com` // 用户
  httpContent = `${httpFirst}pc-api.pre.xqhuyu.com` // 内容
  httpImg = `${httpFirst}uploads.996box.com`
  httpExtract = `${httpFirst}pay-api.pre.xqhuyu.com` // 充值
  httpIdAuth = `${httpFirst}pre-api.996box.com` // 身份认证
}
// 正式环境
if (process.env.NODE_ENV === 'production') {
  httpAddress = `${httpFirst}charge-api.996box.com` // 打包后请求域名
  httpUser = `${httpFirst}user-api.996box.com` // 用户
  httpContent = `${httpFirst}pc-api.996box.com` // 内容
  httpImg = `${httpFirst}uploads.996box.com`
  httpExtract = `${httpFirst}pay-api.996box.com` // 充值
  httpIdAuth = `${httpFirst}api.996box.com` // java接口域名
}

const firstVersoin = `/v1` // 第一版
const InfoUrl = `/UserInfo` // 通用
const secondVersoin = `/v2` // 第一版
const thirdlyVersoin = `/v3` // 第三版
const RegisterUrl = `/Register` // 注册
const loginUrl = `/Login` // 登录
let baseUrl = ``

// 是否为开发环境
if (process.env.NODE_ENV === 'development') {
  httpAddress = `` // 请求域名
  // httpUser = ``;  // 用户
  // httpContent = ``;  // 内容
  baseUrl = `/api`
}

export default {
  user: {
    // 登录
    login: `${baseUrl}/user/login`,
    // 登出
    logout: `${baseUrl}/user/logout`,
    // 获取用户信息
    getInfo: `${httpUser}/v1/UserInfo/getByRefresh`,
    // 获取用户信息(新)
    newGetInfo: `${httpUser}${thirdlyVersoin}/User/info`,
    // 获取菜单
    getMenu: `${baseUrl}/user/getMenu`,
    // 获取用户信息
    getUserInfo: `${baseUrl}/getUserInfo`,
    // 上传图片
    imageUpload: `${httpImg}/cdnapp/universalUpload.php`,
    // 反馈意见类型配置
    opinionConfig: `${httpAddress}${baseUrl}/user/opinionConfig`,
    // 反馈意见
    buyOrder: `${httpAddress}${baseUrl}/user/opinion`,
    // 我的收藏
    collectList: `${httpAddress}${baseUrl}/commodity/collectList`,
    // 我的货架
    sell: `${httpAddress}${baseUrl}/commodity/my/sell`,
    // 上架商品
    onshelf: `${httpAddress}${baseUrl}/commodity/onshelf`,
    // 下架商品
    downshelf: `${httpAddress}${baseUrl}/commodity/downshelf`,
    // 取回
    takeBack: `${httpAddress}${baseUrl}/commodity/takeBack`,
    // 修改价格
    modifyPrice: `${httpAddress}${baseUrl}/commodity/modify/price`,
    // 我要卖数据接口
    sellInfo: `${httpAddress}${baseUrl}/commodity/sellInfo`,
    // 获取角色货币余额
    coinNum: `${httpAddress}${baseUrl}/commodity/coinNum`,
    // 给用户的手机号发送验证码
    sendSms: `${httpAddress}${baseUrl}/sms/user/send`,
    // 校验验证码
    checkSms: `${httpAddress}${baseUrl}/sms/check`,
    // 发布商品
    publish: `${httpAddress}${baseUrl}/commodity/publish`,
    // 指定我
    target: `${httpAddress}${baseUrl}/commodity/target`,
    // 删除指定
    cancelTarget: `${httpAddress}${baseUrl}/commodity/cancelTarget`,
    // 身份证照片获取身份证信息
    authidcard: `${httpAddress}${baseUrl}/auth/idcard`,
    // 提交实名信息
    authpersonal: `${httpAddress}${baseUrl}/auth/personal`,
    // 提交实名认证---带滑块
    imgPersonal: `${httpUser}${thirdlyVersoin}/Identify/imgPersonal`,
    // 获取交易行规则内容
    getHelp: `${httpAddress}${baseUrl}/help.txt`,
    // 获取交易币说明
    // tradeCoin: `${httpAddress}${baseUrl}/trade_coin.txt`,
    tradeCoin: `//charge-api.996box.com/trade_coin.txt`,
    // 以认证用户实名的账号数 ----- 林晨飞
    countIdCard: `${httpUser}${secondVersoin}/Identify/countIdCard`,
    // 身份证信息最多认证数
    authLimit: `${httpIdAuth}/user/v1/auth/limit`,
  },
  order: {
    // 我买的/我卖的订单
    buyOrder: `${httpAddress}${baseUrl}/order/list`,
    // 指定我的订单
    mycommodity: `${httpAddress}${baseUrl}/commodity/target`,
    // 买家订单详情
    purchaseDetail: `${httpAddress}${baseUrl}/order/purchase/detail`,
    // 取消订单
    orderCancel: `${httpAddress}${baseUrl}/order/cancel`,
    // 删除订单
    orderDel: `${httpAddress}${baseUrl}/order/del`,
    // 卖家订单详情
    sellDetail: `${httpAddress}${baseUrl}/order/sell/detail`,
    // 下单
    place: `${httpAddress}${baseUrl}/order/place`
  },
  loginHome: {
    // 账号登录
    LoginInfo: `${httpUser}/v1/Login/byPwd`,
    // 登出
    logout: `${httpUser}/v1/UserInfo/logout`,
    // 账号不存在则注册
    judgePhoneLogin: `${httpUser}/v1/Register/byPhoneLogin`,
    // 获取手机号验证码
    getPhoneCode: `${httpUser}/v1/UserInfo/get_phone_code`,
    // 校验手机验证码
    checkPhoneCode: `${httpUser}/v1/UserInfo/check_phone_code`,
    // 账号名密码登陆 不存在则注册一个
    loginOrReg: `${httpUser}/v1/Login/loginOrReg`,
    // 手机号登录 不存在则注册一个
    phoneLogin: `${httpUser}/v1/Login/phoneLogin`,
    // 绑定手机号
    bindPhone: `${httpUser}/v1/UserInfo/bindPhone`,
    // 校验手机号是否存在
    checkPhoneExist: `${httpUser}${firstVersoin}${InfoUrl}/checkPhoneExist`,
    // 解绑手机-校验验证码，并生成修改token
    checkUnbindPhoneCode: `${httpUser}${firstVersoin}${InfoUrl}/checkUnbindPhoneCode`,
    // 解绑手机-根据token解绑手机
    unbindPhoneByToken: `${httpUser}${firstVersoin}${InfoUrl}/UnbindPhoneByToken`,
    // token绑定手机号
    bindPhoneByToken: `${httpUser}${firstVersoin}${InfoUrl}/bindPhoneByToken`,
    // 账号密码注册-带验证码
    registerUname: `${httpUser}${firstVersoin}${RegisterUrl}/uname`,
    // 根据用户名查询手机号
    getPhoneByUsername: `${httpUser}${firstVersoin}${InfoUrl}/getPhoneByUsername`,
    // 根据用户名获取手机号前四位
    getPhonePreByUsername: `${httpUser}${firstVersoin}/UserInfo/getPhonePreByUsername`,
    // 用户名密码注册
    secondVersoin: `${httpUser}${secondVersoin}${RegisterUrl}/uname`,
    // 用户名密码登陆
    loginbypwd: `${httpUser}${secondVersoin}${loginUrl}/bypwd`,
    // 手机验证码登陆
    phoneRegister: `${httpUser}${secondVersoin}${loginUrl}/phoneLogin`,
    // 用户名密码注册接口-带滑块验证
    registerSlider: `${httpUser}${secondVersoin}${RegisterUrl}/username`,
    // 用户名密码登陆-带滑块验证
    bypassword: `${httpUser}${secondVersoin}${loginUrl}/bypassword`
  },
  PassWord: {
    // 未登录时修改密码
    changeByPhone: `${httpUser}/v1/PassWord/changeByPhone`
  },
  homeIndex: {
    // 首页
    appHomePage: `${httpAddress}${baseUrl}/game/appHomePage`,
    // 获取区服列表
    districtList: `${httpAddress}${baseUrl}/game/district/list`,
    // 获取角色列表
    roleList: `${httpAddress}${baseUrl}/game/role/list`,
    // 获取商品筛选项
    commodityConfig: `${httpAddress}${baseUrl}/commodity/config`,
    // 商品列表
    commodityList: `${httpAddress}${baseUrl}/commodity/list`,
    // 商品详情
    commodityDetail: `${httpAddress}${baseUrl}/commodity/detail`,
    // 商品收藏
    commodityCollect: `${httpAddress}${baseUrl}/commodity/collect`,
    // 取消收藏
    commodityCancelCollect: `${httpAddress}${baseUrl}/commodity/cancelCollect`
  },
  game: {
    // 获取全部游戏
    AllGame: `${httpAddress}${baseUrl}/game/pclist`,
    // 获取最近在玩
    userGame: `${httpAddress}${baseUrl}/game/userGame`,
    // 获取版本与特色
    AllVersionAndTag: `${httpContent}/v1/homeapi/FindGame/getAllVersionAndTagList`,
    // 获取角色列表
    list: `${httpAddress}${baseUrl}/game/role/list`
  },
  pay: {
    // 交易币支付
    orderTradePay: `${httpAddress}${baseUrl}/pay/orderTradePay`,
    // h5支付
    hpay: `${httpAddress}${baseUrl}/pay/h5pay`,
    // 提现配置
    extractInfo: `${httpExtract}/v2/Extract/info`,
    // 提现申请
    extractApply: `${httpExtract}/v3/Extract/Apply`,
    // 提现申请列表
    extractrList: `${httpExtract}/v1/Extract/ExtractrList`,
    // 更改提现列表小红点状态
    readExtract: `${httpExtract}/v1/Extract/readExtract`,
    // 盒子充值档位
    BoxPayGrade: `${httpExtract}/v1/RoleInfo/BoxPayGrade`,
    // 充值账号校验
    CheckUser: `${httpExtract}/v1/RoleInfo/CheckUser`,
    // 支付宝sdk支付
    H5AlipayBox: `${httpExtract}/v1/MobilePay/SdkAlipayBox`,
    // 微信sdk支付
    H5WechatBox: `${httpExtract}/v1/MobilePay/H5WechatBox`,
    // 金币提现签约
    userSign: `${httpExtract}/v1/Extract/userSign`,
    // 用户人脸签约（参数：uid）
    userSignFace: `${httpExtract}/v3/extract/userSignFace`,
    // 金币提现签约查询接口
    getUserSign: `${httpExtract}/v1/Extract/getUserSign`,
    // 撤销提现（交易币提现到盒币）
    cancelApply: `${httpExtract}/v2/Extract/cancelApply`,
    // SVIP用户信息查询
    querySvipUserInfo: `${httpIdAuth}/svip/v1/querySvipUserInfo`,
    // 极速提现申请 --- 张志国
    SpeedUpApply: `${httpExtract}/v2/Extract/SpeedUpApply`,
    // 快速提现SVIP弹窗查询 --- 白金泽
    queryFastCashSvipPopupInfo: `${httpIdAuth}/svip/v1/queryFastCashSvipPopupInfo`
  },
  signKeyCollect,
  signKeyV0,
  signKey,
  newSignKey,
  signKeyV3,
}
